export default __webpack_public_path__ + "static/media/usdc.8325c159.png";